/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Center_Errors_ReportInputs */



/**
* | output |
* | --- |
* | "Report to support" |
*
* @param {Activity_Center_Errors_ReportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_errors_report = /** @type {((inputs?: Activity_Center_Errors_ReportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Errors_ReportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("An den Support melden")
	return /** @type {LocalizedString} */ ("Report to support")
});